import "./header-view.css";
import header_logo from "../assets/PEP_IAM_Central_logo.png";
import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Header,
  Icon,
  NotificationMenu,
  ProfileMenu
} from "pepsico-ds";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import URLData from "../Data/URL-Data";
import ReactDOM from "react-dom/client"
import { UserProfileContext } from "./user_profile_context";

function HeaderView({ isMenuClicked, sidebarRef, headerRef, roles }) {
  const { oktaAuth } = useOktaAuth();
  const { t, i18n } = useTranslation();
  const [langSelected, setLangSelected] = useState("en");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();
  const { userProfile } = useContext(UserProfileContext);
  const [menuClicked, setMenuClicked] = useState(false);
  const { REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI } = process.env;
  const logoutUrl = REACT_APP_OKTA_POST_LOGOUT_REDIRECTURI;
  const data = JSON.parse(localStorage.getItem("okta-token-storage"));

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    setLangSelected(
      localStorage.getItem("lang") ? localStorage.getItem("lang") : "en"
    );
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {

    const handleOutsideClick = (event) => {
      const isSidebarCollapsed = document.querySelector(".sidebar.expanded");
      if (headerRef.current && headerRef.current.contains(event.target) && isSidebarCollapsed) {
        openMobileMenu();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [sidebarRef, headerRef, isMenuClicked]);

  // Set user name from the token storage
  if (!userName && data?.accessToken?.claims?.displayname) {
    setUserName(data?.accessToken?.claims?.displayname);
  }

  const changeLanguage = (lng) => {
    // setLangSelected(lng);
    i18n.changeLanguage(lng); // Assuming you're using i18next
    document.body.setAttribute("data-lang", lng);
    document.documentElement.setAttribute("dir", lng === "ar" ? "rtl" : "ltr");
    // window.location.reload();
  };

  const langSelection = (lang) => {
    const languageCode = lang === 0 ? "en" : lang === 1 ? "es" : lang === 2 ? "fr" : lang === 3 ? "pt" : lang === 4 ? "ru" : lang === 5 ? "zh" : lang === 6 ? "ar" : "";
    localStorage.setItem("lang", languageCode);
    localStorage.setItem("userSelLang", languageCode);
    setLangSelected(languageCode);
    changeLanguage(languageCode);
  };

  const navigateToHome = () => {
    navigate("/home");
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // window.location.href = "/home";
  };

  const Logout = (index) => {
    if (index == 1) {
       navigate( userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? "/update-profile" : "/view-profile"); // Redirect to /update-profile
      // navigate("/manage-accounts"); // Redirect to /manage-accounts
      // window.open(
      //   `${JSON.parse(localStorage.getItem("okta-token-storage"))
      //     ?.idToken?.claims?.email?.toLocaleLowerCase()
      //     .includes("contractor")
      //     ? "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyNonEmployeeProfileForAnother"
      //     : "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyEmployeeProfile"
      //   }`,
      //   "_blank",
      //   "noopener noreferrer"
      // );
    } else if (index == 2) {
      // if (roles && roles?.includes("iChangePassword")) {
      navigate('/change-password');
      // }
      // else {
      //   URLData.OPEN_URL_CHECKER("myidm", "change_password");
      // }
    } else if (index === 3) {
      const storedVersion = localStorage.getItem("app_version");
      localStorage.clear();
      localStorage.setItem("app_version", storedVersion || "");
      clearListCookies();
      // window.location.reload();
      localStorage.setItem("logout", true);
      const date = new Date();
      date.setTime(date.getTime() + 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();
      document.cookie = "logout= true;" + expires + ";path=/";
      console.log(logoutUrl, 'header')
      setTimeout(() => {
        oktaAuth.signOut({
          postLogoutRedirectUri: logoutUrl,
        });
      }, 100);
      //oktaAuth.redirect("/logout");
    }
  };
  const clearListCookies = () => {
    var cookies2 = document.cookie.split(";");
    for (let i = 0; i < cookies2.length; i++) {
      let spcook = cookies2[i].split("=");
      document.cookie = spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
    }
    var cookiesList = document.cookie.split(";");
  };
  const onSelection = (val) => {
    if (val == 1) {
      // navigate("/manage-accounts"); // Redirect to /manage-accounts
      window.open(
        `${JSON.parse(localStorage.getItem("okta-token-storage"))
          ?.idToken?.claims?.email?.toLocaleLowerCase()
          .includes("contractor")
          ? "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyNonEmployeeProfileForAnother"
          : "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyEmployeeProfile"
        }`,
        "_blank",
        "noopener noreferrer"
      );
    } else if (val == 2) {
      // URLData.OPEN_URL_CHECKER("myidm", "change_password");
      navigate('/change-password'); // Redirect to /change-password
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if sidebar is expanded
      const isSidebarCollapsed = document.querySelector(".sidebar.collapsed");

      // If sidebar is expanded and the click is outside, collapse the sidebar
      if (isSidebarCollapsed && window.innerWidth <= 768) {
        setMenuClicked((prev) => {
          const newValue = !prev;
          isMenuClicked(newValue); // Use the updated value directly
          return newValue;
        });
      }
    };

    // Add event listener to detect clicks outside the sidebar
    document.addEventListener("click", handleOutsideClick);

    return () => {
      // Remove event listener to avoid memory leaks
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(()=>{
    const mainLogo = document.querySelector(".header-pepsico-logo");
    mainLogo.innerHTML = null;
    ReactDOM.createRoot(mainLogo).render(
      <div style={{ display: "flex", gap: "1rem" }}>
        {isMobile ? (
          <Icon
            alt="menu"
            icon="menu"
            style={{ color: "white" }}
            onClick={openMobileMenu}
            size="medium"
          />
        ) : null}{" "}
        {/* {!isMobile ? ( */}
          <img
            src={header_logo}
            onClick={navigateToHome}
            style={{
              height:'50px',
              cursor: "pointer",
              filter: "invert(0) grayscale(1) brightness(1000%)",
            }}
            alt="Pepsico"
          />
        {/* ) : null} */}
      </div>
    )
  },[isMobile])

  const openMobileMenu = () => {
    setMenuClicked((prev) => !prev);
    isMenuClicked(!menuClicked);
  };

  return (
    <div>
      <Header
        leftIcon={
          <>
            <div style={{ display: "flex" }}>
              {isMobile ? (
                <Icon
                  alt="menu"
                  icon="menu"
                  style={{ color: "white" }}
                  onClick={openMobileMenu}
                  size="medium"
                />
              ) : null}{" "}
              {/* {!isMobile ? ( */}
                <img
                  src={header_logo}
                  onClick={navigateToHome}
                  style={{
                    height:'34px',
                    cursor: "pointer",
                    filter: "invert(0) grayscale(1) brightness(1000%)",
                  }}
                  alt="Pepsico"
                />
              {/* ) : null} */}
            </div>
          </>
        }
        middleIcon={
          <>
            {isMobile ? (
              <img onClick={navigateToHome}
                src={header_logo}
                style={{
                  width: "115px",
                  filter: "invert(0) grayscale(1) brightness(1000%)",
                }}
                alt="Pepsico"
              />
            ) : null}
            <h6
              className="font-body-bold text-white iamheaderText"
              style={{ fontWeight: "500", marginTop: "6px" }}
            >
              {t("identity_&_access_management_central")}
            </h6>
          </>
        }
        appLogoProps={{
          className: !isMobile ? "pepsico-logo" : "",
          appName: !isMobile ? `${t("identity_&_access_management_central")}` : "",
          colorStyle: "white",
          logoType: !isMobile ? "appLogo" : "",
        }}
        menuIconProps={{
          alt: "menu",
          className: "$color-icon-white",
          icon: "menu",
          onClick: function Qa() { },
          size: "medium",
        }}
        pepsicoFullLogoProps={{
          className: "pepsico-logo",
          colorStyle: "white",
          logoType: "pepsicoFullLogo",
        }}
        rightToolbar={[
          // {
          //   dropdownContent: (
          //     <NotificationMenu
          //       bottomButtonProps={{
          //         iconTrailing: "arrow_forward",
          //         onClick: () => Qa(),
          //         size: "small",
          //         text: "See all Notifications",
          //         variant: "borderless",
          //       }}
          //       onUpdate={function Qa() { }}
          //       options={[
          //         {
          //           details: "You are upto date with all the notifications",
          //           footerText: "2 min ago",
          //           isDark: false,
          //           link2Props: {
          //             iconLeading: "",
          //             iconTrailing: "arrow_forward",
          //             label: "View",
          //             onClick: () => Qa(),
          //             size: "small",
          //             useAnchor: true,
          //           },
          //           separator: true,
          //           showBadge: false,
          //           showDotIcon: false,
          //           showLink: true,
          //           title: "No Notification ",
          //           type: "row",
          //         },
          //         // {
          //         //   details: "Long text description with max two lines...",
          //         //   footerText: "2 min ago",
          //         //   isDark: false,
          //         //   link2Props: {
          //         //     iconLeading: "",
          //         //     iconTrailing: "arrow_forward",
          //         //     label: "View",
          //         //     onClick: () => Qa(),
          //         //     size: "small",
          //         //     useAnchor: true,
          //         //   },
          //         //   separator: true,
          //         //   showBadge: false,
          //         //   showDotIcon: false,
          //         //   showLink: true,
          //         //   title: "Associate PAAS Account",
          //         //   type: "row",
          //         // },
          //       ]}
          //       popoverProps={{
          //         direction: "top-right",
          //         showPopover: true,
          //         text: "Notifications",
          //       }}
          //       style={{ width: "290px" }}
          //     />
          //   ),
          //   icon: (
          //     !isMobile ? <Icon
          //       alt="alt value"
          //       className="$color-icon-white"
          //       icon="notifications"
          //       size="medium"
          //     /> : null
          //   ),
          //   onClickIcon: () => Qa(),
          // },
          {
            icon: !isMobile ? (
              <button
                onClick={() => {
                  window.dispatchEvent(new CustomEvent("startTour"));
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  width:"0px"
                }}
                title="Start Tour"
              >
                <Icon
                  alt="Start Tour"
                  className="$color-icon-white"
                  icon="play_arrow"
                  size="large"
                  width="0px"
                />
              </button>
            ) : null,
          },
          {
            dropdownContent: (
              <NotificationMenu
                onUpdate={langSelection}
                options={[
                  {
                    separator: true,
                    className:
                      langSelected === "en" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "English",
                    type: "row",
                    onClick: () => langSelection("English"),
                    defaultValue: "English",
                  },
                  {
                    separator: true,
                    className:
                      langSelected === "es" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "Español",
                    type: "row",
                    onClick: () => langSelection("Español"),
                    defaultValue: "Español",
                  },
                  {
                    separator: true,
                    className:
                      langSelected === "fr" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "Français",
                    type: "row",
                    onClick: () => langSelection("Français"),
                    defaultValue: "Français",
                  },
                  {
                    separator: true,
                    className:
                      langSelected === "pt" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "Português",
                    type: "row",
                    onClick: () => langSelection("Português"),
                    defaultValue: "Português",
                  },
                  {
                    separator: true,
                    className:
                      langSelected === "ru" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "Русском",
                    type: "row",
                    onClick: () => langSelection("Русском"),
                    defaultValue: "Русском",
                  },
                  {
                    separator: true,
                    className:
                      langSelected === "zh" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "简体中文",
                    type: "row",
                    onClick: () => langSelection("简体中文"),
                    defaultValue: "简体中文",
                  },
                  {
                    separator: true,
                    className:
                      langSelected === "ar" ? "lang-row active" : "lang-row",
                    showBadge: false,
                    showDotIcon: false,
                    showLink: true,
                    title: "العربية",
                    type: "row",
                    onClick: () => langSelection("العربية"),
                    defaultValue: "العربية",
                  },
                ]}
                popoverProps={{
                  direction: "top-right",
                  showPopover: true,
                  text: "Languages",
                }}
                style={{ width: "290px" }}
              />
            ),
            icon: (!isMobile || isMobile) ? (
              <Icon
                alt="alt value"
                className="$color-icon-white"
                icon="language"
                size="medium"
              />
            ) : null,
          },
          {
            dropdownContent: (
              <ProfileMenu
                onUpdate={Logout}
                options={[
                  {
                    avatarProps: {
                      icon: "account_circle",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    badgeProps: {
                      color: "Cyan-500",
                      isRemovable: true,
                      onRemove: function Qa() { },
                      size: "large",
                      text: "Label",
                      type: "filled",
                    },
                    deleteIconProps: {
                      icon: "delete",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    details: "",
                    downloadIconProps: {
                      icon: "download",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    isDark: true,
                    leadingIconProps: {
                      icon: "account_circle",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    linkProps: {
                      iconLeading: "",
                      iconTrailing: "chevron_right",
                      label: "Link",
                      size: "small",
                      useAnchor: true,
                    },
                    radioButtonProps: {
                      items: ["Radio Label"],
                      label: "",
                      onUpdate: function Qa() { },
                      reference: "radio button",
                      size: "large",
                    },
                    separator: true,
                    showBadge: false,
                    showDotIcon: false,
                    showLink: false,
                    tertiaryButtonProps: {
                      iconTrailing: "chevron_right",
                      onClick: function Qa() { },
                      size: "small",
                      text: "Button",
                      variant: "tertiary",
                    },
                    title: userName,
                    trailingIconProps: {
                      icon: "info_outline",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    className: "cursor-default",
                    type: "row",
                  },
                  {
                    avatarProps: {
                      icon: "account_circle",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    badgeProps: {
                      color: "Cyan-500",
                      isRemovable: true,
                      onRemove: function Qa() { },
                      size: "large",
                      text: "Label",
                      type: "filled",
                    },
                    deleteIconProps: {
                      icon: "delete",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    details: "",
                    downloadIconProps: {
                      icon: "download",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    isDark: true,
                    leadingIconProps: {
                      icon: "settings",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    linkProps: {
                      iconLeading: "",
                      iconTrailing: "chevron_right",
                      label: "Link",
                      size: "small",
                      useAnchor: true,
                    },
                    radioButtonProps: {
                      items: ["Radio Label"],
                      label: "",
                      onUpdate: function Qa() { },
                      reference: "radio button",
                      size: "large",
                    },
                    separator: true,
                    showBadge: false,
                    showDotIcon: false,
                    showLink: false,
                    tertiaryButtonProps: {
                      iconTrailing: "chevron_right",
                      onClick: function Qa() { },
                      size: "small",
                      text: "Button",
                      variant: "tertiary",
                    },
                    onClick: (val) => onSelection(val),
                    title: userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("homePage.update_profile") : t("homePage.view_profile"),
                    trailingIconProps: {
                      icon: "info_outline",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    type: "row",
                  },
                  {
                    avatarProps: {
                      icon: "account_circle",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    badgeProps: {
                      color: "Cyan-500",
                      isRemovable: true,
                      onRemove: function Qa() { },
                      size: "large",
                      text: "Label",
                      type: "filled",
                    },
                    deleteIconProps: {
                      icon: "delete",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    details: "",
                    downloadIconProps: {
                      icon: "download",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    isDark: true,
                    leadingIconProps: {
                      icon: "double_arrow",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    linkProps: {
                      iconLeading: "",
                      iconTrailing: "chevron_right",
                      label: "Link",
                      size: "small",
                      useAnchor: true,
                    },
                    radioButtonProps: {
                      items: ["Radio Label"],
                      label: "",
                      onUpdate: function Qa() { },
                      reference: "radio button",
                      size: "large",
                    },
                    separator: true,
                    showBadge: false,
                    showDotIcon: false,
                    showLink: false,
                    tertiaryButtonProps: {
                      iconTrailing: "chevron_right",
                      onClick: function Qa() { },
                      size: "small",
                      text: "Button",
                      variant: "tertiary",
                    },
                    onClick: () => onSelection("change_password"),
                    title: t("homePage.change_password"),
                    trailingIconProps: {
                      icon: "info_outline",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    type: "row",
                  },
                  {
                    avatarProps: {
                      icon: "account_circle",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    badgeProps: {
                      color: "Cyan-500",
                      isRemovable: true,
                      onRemove: function Qa() { },
                      size: "large",
                      text: "Label",
                      type: "filled",
                    },
                    deleteIconProps: {
                      icon: "delete",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    details: "",
                    downloadIconProps: {
                      icon: "download",
                      onClick: function Qa() { },
                      showIcon: false,
                    },
                    isDark: true,
                    leadingIconProps: {
                      icon: "add_alert",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    linkProps: {
                      iconLeading: "",
                      iconTrailing: "chevron_right",
                      label: "Link",
                      size: "small",
                      useAnchor: true,
                    },
                    radioButtonProps: {
                      items: ["Radio Label"],
                      label: "",
                      onUpdate: function Qa() { },
                      reference: "radio button",
                      size: "large",
                    },
                    separator: true,
                    showBadge: false,
                    showDotIcon: false,
                    showLink: false,
                    tertiaryButtonProps: {
                      iconTrailing: "chevron_right",
                      onClick: function Qa() { },
                      size: "small",
                      text: "Button",
                      variant: "tertiary",
                    },
                    onClick: () => Logout(),
                    title: t("homePage.logout"),
                    trailingIconProps: {
                      icon: "info_outline",
                      onClick: function Qa() { },
                      showIcon: true,
                    },
                    type: "row",
                  },
                ]}
                style={{ width: "330px" }}
              />
            ),
            icon: (
              <>
                <Icon
                  alt="alt value"
                  svg={
                    <Avatar
                      avatarStyle="circle"
                      iconType="person"
                      imageUrl="https://i.pravatar.cc/150?u=username"
                      // imageUrl="https://randomuser.me/api/portraits/men/1.jpg"
                      name={userName ? userName : "User"}
                      size="small"
                      type="icon"
                    />
                  }
                />
                <Icon
                  alt="alt value"
                  className="$color-icon-white"
                  icon="arrow_drop_down"
                  size="medium"
                />
              </>
            ),
            onClickIcon: function Qa() { },
          },
        ]}
      />
    </div>
  );
}

export default HeaderView;
